'use client';

import { FC, SVGProps } from 'react';

import PcButton from '@/shared/ui/button/PcButton';
import {
  ArrowIcon,
  Asterisk,
  AsteriskLight,
  LocationCircle,
  LocationCircleLight,
  PaperPlane,
  PaperPlaneLight,
} from '@/shared/ui/svgs';

export type CardTheme = 'lightBlue' | 'gradientBlue';
export type IconType =
  | 'location'
  | 'locationLight'
  | 'asterisk'
  | 'asteriskLight'
  | 'paperPlane'
  | 'paperPlaneLight';

const themes: Record<
  CardTheme,
  {
    background: string;
    text: string;
  }
> = {
  gradientBlue: {
    background: 'bg-gradient-to-br from-[#009EFF] to-[#004EFF]',
    text: 'text-secondary-white',
  },
  lightBlue: {
    background: 'bg-[#F0F5FF]',
    text: 'text-secondary-black',
  },
};

const icons: Record<IconType, FC<SVGProps<SVGSVGElement>>> = {
  location: LocationCircle,
  locationLight: LocationCircleLight,
  asterisk: Asterisk,
  asteriskLight: AsteriskLight,
  paperPlane: PaperPlane,
  paperPlaneLight: PaperPlaneLight,
};

interface PcQuickServiceCardProps {
  theme: CardTheme;
  title: string;
  iconType: IconType;
}

const PcQuickServiceCard = ({ theme, title, iconType }: PcQuickServiceCardProps) => {
  const currentTheme = themes[theme];
  const BackgroundIcon = icons[iconType];
  const buttonVariant = theme === 'gradientBlue' ? 'white' : 'outline';
  // const cleanDescription = description.replace(/\|/g, ''); //모바일 description | 분기로 인한 추가
  return (
    <div
      className={`relative w-full max-w-[411px] h-[480px] rounded-[40px] cursor-pointer ${currentTheme.background}`}
    >
      <div className={'absolute right-0'}>
        <BackgroundIcon />
      </div>
      <PcButton
        shape="circle"
        variant={buttonVariant}
        size={56}
        className="absolute top-[40px] left-[40px]"
      >
        <ArrowIcon color={theme === 'gradientBlue' ? 'blue' : 'black'} />
      </PcButton>
      <div className={`absolute bottom-[40px] left-[40px] right-[40px] ${currentTheme.text}`}>
        <div className={'text-locale-28 mb-[16px] font-bold'}>{title}</div>
        {/*<div className={'text-locale-18 font-medium'}>{cleanDescription}</div>*/}
      </div>
    </div>
  );
};

export default PcQuickServiceCard;
